import { render, staticRenderFns } from "./OriReporte.vue?vue&type=template&id=49ce9ca3&scoped=true"
import script from "./OriReporte.vue?vue&type=script&lang=js"
export * from "./OriReporte.vue?vue&type=script&lang=js"
import style0 from "./OriReporte.vue?vue&type=style&index=0&id=49ce9ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce9ca3",
  null
  
)

export default component.exports